module.exports = __webpack_public_path__ + "img/MA.f00c6c8a.png";